import React, {createContext, PropsWithChildren} from 'react';

export const CacheablePlaceholdersProvider: React.FC<
  PropsWithChildren<ContextValue>
> = ({children, ...value}) => {
  return (
    <CacheablePlaceholdersContext.Provider value={value}>
      {children}
    </CacheablePlaceholdersContext.Provider>
  );
};

type ContextValue = {
  placeholders: string[];
  forceRenderPlaceholders?: boolean;
};

const CacheablePlaceholdersContext = createContext<ContextValue>({
  placeholders: [],
  forceRenderPlaceholders: false,
});

export const CacheableWrapper: React.FC<
  PropsWithChildren<{placeholder: string}>
> = ({children, placeholder}) => {
  const {placeholders, forceRenderPlaceholders} = React.useContext(
    CacheablePlaceholdersContext,
  );
  const shouldRenderPlaceholder =
    forceRenderPlaceholders || placeholders.includes(placeholder);

  if (!process.browser && shouldRenderPlaceholder) {
    return <>{placeholder}</>;
  }

  return <>{children}</>;
};
